import { AirwayConstants } from './airway.constants'
import { IAirwayNabc, IAssessmentsAirwayAction, IAssessmentsAirwayState } from './airway.types'

export const initialAirwayNabc: IAirwayNabc = {
  airStatus: {
    id: 1,
    name: 'Patent',
  },
  airType: null,
  airComments: '',
  airEttSize: '',
  airEttSizeUnit: '',
  airEttLips: '',
  airBy: null,
  airOutcome: null,
  broselow: null,
  broselowPNNV: null,
  __airEttSizeUnit: null,
}

export const initialAssessmentsAirwayState: IAssessmentsAirwayState = {
  prAirwayVerificationAssess: [],
  prAirwayAssess: [],
  prNabc: initialAirwayNabc,
}

export function initialAssessmentsAirwayReducer(
  state: IAssessmentsAirwayState = initialAssessmentsAirwayState,
  action: IAssessmentsAirwayAction
): IAssessmentsAirwayState {
  switch (action.type) {
    case AirwayConstants.SET_VERIFICATION_METHODS:
      return {
        ...state,
        prAirwayVerificationAssess: action.prAirwayVerificationAssess,
      }
    case AirwayConstants.SET_EXAM:
      return {
        ...state,
        prAirwayAssess: action.prAirwayAssess,
      }
    case AirwayConstants.SET_STATUS:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airStatus: action.airStatus,
        },
      }
    case AirwayConstants.SET_SECURED_VIA:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airType: action.airType,
        },
      }
    case AirwayConstants.SET_TUBE_SIZE:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airEttSize: action.airEttSize,
        },
      }
    case AirwayConstants.SET_TUBE_SIZE_UNIT:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airEttSizeUnit: action.airEttSizeUnit,
        },
      }
    case AirwayConstants.SET_TUBE_SIZE_UNIT_CLIENT:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          __airEttSizeUnit: action.__airEttSizeUnit,
        },
      }
    case AirwayConstants.SET_DEPTH:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airEttLips: action.airEttLips,
        },
      }
    case AirwayConstants.SET_INITIAL_ASSESSMENT_AIRWAY_COMMENTS:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airComments: action.airComments,
        },
      }
    case AirwayConstants.SET_PERFORMED_BY:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airBy: action.airBy,
        },
      }
    case AirwayConstants.SET_OUTCOME:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          airOutcome: action.airOutcome,
        },
      }
    case AirwayConstants.SET_LENGTH_BASED_TAPE_MEASURE:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          broselow: action.broselow,
        },
      }
    case AirwayConstants.SET_LENGTH_BASED_TAPE_MEASURE_PNNV:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          broselowPNNV: action.broselowPNNV,
        },
      }
    case AirwayConstants.SAVE_INITIAL_ASSESSMENT_AIRWAY_NABC:
      return {
        ...state,
        prNabc: { ...state.prNabc, ...action.prNabc },
      }
    case AirwayConstants.RESET_INITIAL_ASSESSMENT_AIRWAY:
      return {
        prAirwayVerificationAssess: [],
        prAirwayAssess: [],
        prNabc: {
          airStatus: {
            id: 1,
            name: 'Patent',
          },
          airType: null,
          airComments: '',
          airEttSize: '',
          airEttSizeUnit: '',
          airEttLips: '',
          airBy: null,
          airOutcome: null,
          broselow: null,
          broselowPNNV: null,
          __airEttSizeUnit: {
            id: 0,
            name: 'mm',
          },
        },
      }

    default:
      return state
  }
}
